































import { DashboardService } from "@/services/dashboard.service";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

@Component({

})
export default class AssinaturasExpiradasTable extends Mixins(GlobalMixin) {
  assinaturasExpiradas: string[] = [];
  loadingAssinaturas = false;
  intervalId = 0;

  @Prop() readonly date!: string | null;

  mounted() {
    this.onChangeDate();
  }

  @Watch("date")
  onChangeDate() {
    this.carregarListaAssinaturasExpiradas();
    this.intervalId = setInterval(() => this.carregarListaAssinaturasExpiradas(), 10000);
  }

  async carregarListaAssinaturasExpiradas() {
    this.loadingAssinaturas = true;
    if (this.date) {
      this.assinaturasExpiradas = await DashboardService.ListaAssinaturasExpiradas(this.date).finally(
        () => (this.loadingAssinaturas = false)
      );
    }
  }

  beforeDestroy() {
    clearInterval(this.intervalId);
  }
}
